import { ComponentProps } from 'react';
import { SettingsIcon } from 'lucide-react';

import { Card } from '@@/primitives/Card';
import { EnvironmentVariablesFieldset } from '@@/form-components/EnvironmentVariablesFieldset';

type Props = Pick<
  ComponentProps<typeof EnvironmentVariablesFieldset>,
  'values' | 'onChange' | 'errors'
>;

export function EnvironmentVariables({ values, onChange, errors }: Props) {
  return (
    <Card.Container>
      <Card.Header title="Environment variables" icon={SettingsIcon} />
      <Card.Body>
        <EnvironmentVariablesFieldset
          values={values}
          onChange={onChange}
          errors={errors}
        />
      </Card.Body>
    </Card.Container>
  );
}
